import { defineMessages } from 'react-intl';

export default defineMessages({
    director: {
        id: '_.company_role.director',
        defaultMessage: 'Director'
    },
    shareholder: {
        id: '_.company_role.shareholder',
        defaultMessage: 'Shareholder'
    },
    guarantor: {
        id: '_.company_role.guarantor',
        defaultMessage: 'Guarantor'
    }
});
